import { createApi } from "@reduxjs/toolkit/query/react";
import { listTrapSitesResponse } from "../../types";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";

export const trapSiteApi = createApi({
  reducerPath: "trapSiteApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["TrapSite"],
  endpoints: (builder) => ({
    listTrapSites: builder.query<
      listTrapSitesResponse,
      { org?: string } | void
    >({
      query: (args) => ({ url: "/trap-sites", org: args?.org }),
      providesTags: ["TrapSite"],
      onQueryStarted: withErrorNotification("Failed to list trap sites"),
    }),
  }),
});

export const { useListTrapSitesQuery } = trapSiteApi;
